module.exports = "/_next/static/videos/walkthrough_720p-3aa96d9cc89a7be54a6bbad776d69d2c.mp4";